import styled from "styled-components";
import { SIDEBAR_W, TOPBAR_H } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  padding-top: ${TOPBAR_H};
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

/* Márgenes del diseño: 76px a la izquierda de la barra lateral y 332px a la
   derecha. Por debajo de 1500px el margen derecho se reduce, porque si no las
   cinco tarjetas por fila no caben. */
export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 36px 332px 36px 76px;
  gap: 20px;

  @media (max-width: 1500px) { padding-right: 76px; }
  @media (max-width: 900px)  { padding: 36px 24px; }
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
`;

export const WeeksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

  @media (max-width: 1200px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 800px)  { grid-template-columns: repeat(2, 1fr); }
`;

export const WeekCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  padding: 18px 16px;
  min-height: 190px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/* Relleno para completar la última fila, como en el diseño */
export const EmptyCard = styled.div`
  background: rgba(255, 255, 255, 0.4);
  border-radius: 14px;
  min-height: 190px;
`;

export const WeekTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1b2b3a;
  text-align: center;
`;

export const StatList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: #444;
`;

export const MoodRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const MoodIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
`;

export const InProgressText = styled.p`
  margin: auto 0;
  text-align: center;
  font-size: 0.8rem;
  color: #9aa7b2;
  line-height: 1.5;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;
`;

export const CardButton = styled.button`
  flex: 1;
  padding: 7px 4px;
  border-radius: 7px;
  border: 1.5px solid #2F6D92;
  background: #fff;
  color: #2F6D92;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #f0f8fd; }

  &:disabled, &:disabled:hover {
    border-color: #dfe6ec;
    color: #b6bfc7;
    background: #fff;
    cursor: not-allowed;
  }
`;

/* ── Activities opened ── */
export const Panel = styled.section`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const RangeTabs = styled.div`
  display: inline-flex;
  background: #eef3f6;
  border-radius: 999px;
  padding: 3px;
`;

export const RangeTab = styled.button`
  border: none;
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "#1b5f6e" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#55606b")};

  &:hover { color: ${({ $active }) => ($active ? "#fff" : "#1b5f6e")}; }
`;

export const BarList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const BarRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BarLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.85rem;
  color: #333;
`;

export const BarValue = styled.span`
  color: #55606b;
`;

export const BarTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: #eef2f4;
  overflow: hidden;
`;

export const BarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  width: ${({ $pct }) => $pct}%;
  background: ${({ $strong }) => ($strong ? "#1b5f6e" : "#8fb0b5")};
`;

export const EmptyState = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: #55606b;
`;
